var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { apiFetcher } from "@common/fetchers/api-fetcher";
import { ENDPOINTS } from "@common/constants/endpoints";
import useSWRInfinite from "swr/infinite";
import { useMemo, useState } from "react";
var PAGE_SIZE_DEFAULT = 50;
var useEventCollection = function (pageType, locale, pageSize) {
    var requestOptions = useMemo(function () { return ({
        method: "GET",
    }); }, []);
    var _a = __read(useState(""), 2), month = _a[0], setMonth = _a[1];
    var _b = __read(useState(""), 2), year = _b[0], setYear = _b[1];
    var _c = __read(useState(false), 2), filtersChanged = _c[0], setFiltersChanged = _c[1];
    var handleSetMonth = function (value) {
        setMonth(value);
        setFiltersChanged(true);
    };
    var handleSetYear = function (value) {
        setYear(value);
        setFiltersChanged(true);
    };
    var getKey = function (pageIndex, previousPageData) {
        var _a;
        if (previousPageData && !((_a = previousPageData === null || previousPageData === void 0 ? void 0 : previousPageData.collection) === null || _a === void 0 ? void 0 : _a.length))
            return null;
        if (!pageType)
            return null;
        return [
            "".concat(ENDPOINTS.eventList, "?contentTags=").concat(pageType, "&pageNumber=").concat(pageIndex + 1, "&pageSize=").concat(pageSize || PAGE_SIZE_DEFAULT, "&year=").concat(year, "&month=").concat(month, "&locale=").concat(locale),
            requestOptions,
        ];
    };
    var _d = useSWRInfinite(getKey, apiFetcher), data = _d.data, error = _d.error, isValidating = _d.isValidating, mutate = _d.mutate, size = _d.size, setSize = _d.setSize;
    return {
        pageTypeCollection: data,
        isLastPage: !!(data === null || data === void 0 ? void 0 : data.find(function (x) { return !x.hasNextPage; })),
        error: error,
        isValidating: isValidating,
        mutate: mutate,
        size: size,
        setSize: setSize,
        setMonth: handleSetMonth,
        setYear: handleSetYear,
        month: month,
        year: year,
        filtersChanged: filtersChanged,
    };
};
export { useEventCollection };
